import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { Route } from '@app/core/enums/route.enum';

export const isAuthenticatedGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  return authService.authenticated$.pipe(
    map((authenticated) => authenticated ? true : router.createUrlTree([Route.Login]))
  );
}